import React from 'react';
import { Link } from 'react-router-dom';
import { businessServices, itServices } from '../assets/data/servicesdata';
import ScrollReveal from './ScrollReveal';
import ServiceCarousel from './ServiceCarousel';
import '../styles/servicesComponent.css';

function Services() {
  return (
    <section className="services-component" id="services">
      <div className="container">
        <ScrollReveal className="services-header">
          <p className="section-eyebrow">Our Services</p>
          <h2 className="services-heading">Transform Your Business</h2>
          <p className="services-intro">
            QASHQ delivers the financial discipline and digital capability modern businesses need — with
            clear scope, professional execution, and long-term partnership in mind.
          </p>
        </ScrollReveal>

        <div className="services-categories">
          <ScrollReveal delay={0.05}>
            <ServiceCarousel
              services={businessServices}
              variant="business"
              badgeLabel="Business"
              title="Business Services"
              subtitle="Accounting, compliance, and advisory for confident growth."
            />
          </ScrollReveal>

          <ScrollReveal delay={0.1}>
            <ServiceCarousel
              services={itServices}
              variant="it"
              badgeLabel="Technology"
              title="IT Services"
              subtitle="Software, web, and digital solutions built for real operations."
            />
          </ScrollReveal>
        </div>

        <ScrollReveal className="services-more-wrap" delay={0.12}>
          <Link to="/services" className="btn btn-outline services-more-btn">
            <span>View All Services</span>
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </Link>
        </ScrollReveal>
      </div>
    </section>
  );
}

export default Services;
